import React from 'react';
import { Plus, Award } from 'lucide-react';

const EmptyState = ({ onAdd }) => {
    return (
        <div className="flex flex-col items-center justify-center h-64 bg-white rounded-xl shadow-md border border-gray-100">
            <div className="p-4 bg-orange-50 rounded-full mb-4">
                <Award className="h-12 w-12 text-orange-500" />
            </div>
            <h3 className="text-lg font-semibold text-gray-700 mb-2">Aucun diplôme</h3>
            <p className="text-gray-500 mb-4 text-center max-w-md">
                Vous n'avez pas encore ajouté de diplôme. Cliquez ci-dessous pour ajouter votre premier diplôme.
            </p>
            <button
                onClick={onAdd}
                className="bg-orange-600 text-white px-4 py-2 rounded-lg flex items-center hover:bg-orange-700 transition mx-auto"
            >
                <Plus size={18} className="mr-2" />
                Ajouter un diplôme
            </button>
        </div>
    );
};

export default EmptyState;
